import { render, staticRenderFns } from "./area_service.vue?vue&type=template&id=2c6b22e4&scoped=true&"
import script from "./area_service.vue?vue&type=script&lang=js&"
export * from "./area_service.vue?vue&type=script&lang=js&"
import style0 from "./area_service.vue?vue&type=style&index=0&id=2c6b22e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b22e4",
  null
  
)

export default component.exports